// extracted by mini-css-extract-plugin
export default {"groupNode":"GroupNode_groupNode__Lmm-C","innerWrapper":"GroupNode_innerWrapper__rhjz8","icon":"GroupNode_icon__ZfIRm"};